import React from "react";
import { useNavigate } from 'react-router-dom';
import "./CustomSolutions.css";
import setting from "./icons/setting.png";
import overview from "./icons/overview.png";
import card1 from "./icons/c1.png";
import card2 from "./icons/c2.png";
import card3 from "./icons/c3.png";
import card4 from "./icons/c4.png";
import card5 from "./icons/c5.png";
import phoneIcon from "./icons/phone.png";

import {
  FaChartLine,
  FaUsers,
  FaSlidersH,
  FaExpandArrowsAlt,
  FaClock,
  FaSmile,
} from "react-icons/fa";

import { FaArrowRight, FaCheckCircle } from "react-icons/fa";

import Header from './Header';
import Footer from './Footer';

function CustomSolutionsPage() {
  const navigate = useNavigate();

  const handleNavigateToContact = () => {
    navigate('/contact');
  };

  return (
    <>
      <Header/>
      {/* ================= Hero Section ================= */}
      <section className="custom-hero">
        <div className="custom-hero__inner">
          <div className="custom-hero__content">
            <span className="custom-hero__badge">CUSTOMIZED SOLUTIONS</span>
            <h1 className="custom-hero__title">
              Customized Solutions
              <br />
              Designed For <span className="custom-hero__title--accent">Your</span>
              <br />
              <span className="custom-hero__title--accent">Business</span>
            </h1>
            <p className="custom-hero__subtitle">
              Transform your workflows with tailored configurations and
              solutions built around your business requirements.
            </p>
            <p className="custom-hero__description">
              Every business operates differently, and standard solutions may
              not always meet specific needs. Alvanium provides customization
              services that help organizations create efficient workflows,
              improve productivity, and simplify operations.
            </p>
            <div className="custom-hero__actions">
              <button className="custom-btn custom-btn--primary" onClick={handleNavigateToContact}>
                Get Started
                <span className="custom-btn__arrow">
                  <FaArrowRight className="custom-arrow" />
                </span>
              </button>
            </div>
          </div>
          <div className="custom-hero__media">
            <img
              className="custom-hero-image"
              src={setting}
              alt="Workflow automation and business customization"
            />
          </div>
        </div>
      </section>

      {/* ================= Overview Section ================= */}
      <section className="custom-overview">
        <div className="custom-overview-left">
          <img src={overview} alt="Customized business solutions" />
        </div>
        <div className="custom-overview-right">
          <p className="custom-overview-small">OVERVIEW</p>
          <h2>
            Solutions Built Around {" "} 
            {/* <br /> */}
            <span className="custom-overview-highlight">Your Requirements</span>
          </h2>
          <p className="custom-overview-text">
            At <b>Alvanium</b>, we understand that every organization has unique
            goals, processes, and operational requirements.
          </p>
          <p className="custom-overview-text">
            Instead of forcing businesses to adapt to systems, we customize
            solutions that align with existing workflows and improve efficiency.
            Our objective is to create flexible and scalable solutions that
            support productivity and future business growth.
          </p>
          <div className="custom-overview-features">
            <div className="custom-feature-box">
              <FaCheckCircle className="custom-tick" />
              Existing Workflow Integration
            </div>
            <div className="custom-feature-box">
              <FaCheckCircle className="custom-tick" />
              Flexible & Scalable Solutions
            </div>
            <div className="custom-feature-box">
              <FaCheckCircle className="custom-tick" />
              Productivity Improvement
            </div>
            <div className="custom-feature-box">
              <FaCheckCircle className="custom-tick" />
              Future Business Growth
            </div>
          </div>
        </div>
      </section>
      
      {/* ================= Customization Services ================= */}
      <section className="custom-customized">
        <div className="custom-customized-header">
          <h1>Our Customization {" "}<span className="custom-customized-highlight">Services</span> </h1>
        </div>

        {/* ====== Row 1 – existing cards (01, 02, 03) ====== */}
        <div className="custom-cards">
          {/* Card 01: Jira Workflow Customization */}
          <div className="custom-service-card-wrapper">
            <div className="custom-service-card">
              {/* <span className="custom-card-number">01</span> */}
              <img
                className="custom-card-img"
                src={card1}
                alt="Jira Workflow Customization"
              />
              <p className="custom-card-title">Jira Workflow Customization</p>
              <p className="custom-card-desc">
                Customize Jira workflows according to business processes and
                team requirements.
              </p>
              <ul className="custom-card-list">
                <li><FaCheckCircle className="custom-check-icon" /> Custom workflows</li>
                <li><FaCheckCircle className="custom-check-icon" /> Automation rules</li>
                <li><FaCheckCircle className="custom-check-icon" /> Dashboard setup</li>
                <li><FaCheckCircle className="custom-check-icon" /> Permissions management</li>
                <li><FaCheckCircle className="custom-check-icon" /> Project configuration</li>
              </ul>
            </div>
          </div>

          {/* Card 02: Confluence Customization */}
          <div className="custom-service-card-wrapper">
            <div className="custom-service-card">
              {/* <span className="custom-card-number">02</span> */}
              <img
                className="custom-card-img"
                src={card2}
                alt="Confluence Customization"
              />
              <p className="custom-card-title">Confluence Customization</p>
              <p className="custom-card-desc">
                Organize knowledge-sharing spaces and improve team
                collaboration.
              </p>
              <ul className="custom-card-list">
                <li><FaCheckCircle className="custom-check-icon" /> Custom templates</li>
                <li><FaCheckCircle className="custom-check-icon" /> Page organization</li>
                <li><FaCheckCircle className="custom-check-icon" /> Permissions setup</li>
                <li><FaCheckCircle className="custom-check-icon" /> Knowledge base structure</li>
              </ul>
            </div>
          </div>

          {/* Card 03: Jira Service Management Customization */}
          <div className="custom-service-card-wrapper">
            <div className="custom-service-card">
              {/* <span className="custom-card-number">03</span> */}
              <img
                className="custom-card-img"
                src={card3}
                alt="Jira Service Management Customization"
              />
              <p className="custom-card-title">Jira Service Management Customization</p>
              <p className="custom-card-desc">
                Optimize service workflows and support processes.
              </p>
              <ul className="custom-card-list">
                <li><FaCheckCircle className="custom-check-icon" /> Request workflows</li>
                <li><FaCheckCircle className="custom-check-icon" /> Incident management setup</li>
                <li><FaCheckCircle className="custom-check-icon" /> Service automation</li>
                <li><FaCheckCircle className="custom-check-icon" /> SLA configuration</li>
              </ul>
            </div>
          </div>
        </div>

        {/* ====== Row 2 – existing cards (04, 05) + new card (06) ====== */}
        <div className="custom-cards">
          {/* Card 04: Zendesk Customization */}
          <div className="custom-service-card-wrapper">
            <div className="custom-service-card">
              {/* <span className="custom-card-number">04</span> */}
              <img
                className="custom-card-img"
                src={card4}
                alt="Zendesk Customization"
              />
              <p className="custom-card-title">Zendesk Customization</p>
              <p className="custom-card-desc">
                Create personalized support experiences and improve customer
                engagement.
              </p>
              <ul className="custom-card-list">
                <li><FaCheckCircle className="custom-check-icon" /> Ticket workflow customization</li>
                <li><FaCheckCircle className="custom-check-icon" /> Support process setup</li>
                <li><FaCheckCircle className="custom-check-icon" /> Automation rules</li>
                <li><FaCheckCircle className="custom-check-icon" /> Reporting dashboards</li>
              </ul>
            </div>
          </div>

          {/* Card 05: monday.com Customization */}
          <div className="custom-service-card-wrapper">
            <div className="custom-service-card">
              {/* <span className="custom-card-number">05</span> */}
              <img
                className="custom-card-img"
                src={card5}
                alt="monday.com Customization"
              />
              <p className="custom-card-title">monday.com Customization</p>
              <p className="custom-card-desc">
                Build customized workflows and task management systems.
              </p>
              <ul className="custom-card-list">
                <li><FaCheckCircle className="custom-check-icon" /> Board customization</li>
                <li><FaCheckCircle className="custom-check-icon" /> Task automation</li>
                <li><FaCheckCircle className="custom-check-icon" /> Team workflow setup</li>
                <li><FaCheckCircle className="custom-check-icon" /> Dashboard creation</li>
              </ul>
            </div>
          </div>

          {/* ====== NEW Card 06: Mobile App Customization ====== */}
          <div className="custom-service-card-wrapper">
            <div className="custom-service-card">
              {/* <span className="custom-card-number">06</span> */}
              <img
                className="custom-card-img"
                src={phoneIcon}
                alt="Mobile App Customization"
              />
              <p className="custom-card-title">Mobile App Customization</p>
              <p className="custom-card-desc">
                Customize mobile applications for better user engagement and seamless experiences.
              </p>
              <ul className="custom-card-list">
                <li>
                  <FaCheckCircle className="custom-check-icon" />
                  App workflow customization
                </li>
                <li>
                  <FaCheckCircle className="custom-check-icon" />
                  Push notification setup
                </li>
                <li>
                  <FaCheckCircle className="custom-check-icon" />
                  User interface adjustments
                </li>
                <li>
                  <FaCheckCircle className="custom-check-icon" />
                  Mobile analytics integration
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      
      {/* ================= Benefits Section ================= */}
      <section className="custom-benefits">
        <div className="custom-benefits-header">
          <h2>Benefits Of <span className="custom-benefits-highlight">Custom Solutions</span> </h2>
        </div>
        <div className="custom-benefits-grid">
          <div className="custom-benefit-item">
            <div className="custom-benefit-icon-wrap">
              <FaChartLine className="custom-benefit-icon" />
            </div>
            <p className="custom-benefit-title">Improved Productivity</p>
            <p className="custom-benefit-desc">
              Reduce manual work and improve operational efficiency.
            </p>
          </div>
          <div className="custom-benefit-item">
            <div className="custom-benefit-icon-wrap">
              <FaUsers className="custom-benefit-icon" />
            </div>
            <p className="custom-benefit-title">Better Collaboration</p>
            <p className="custom-benefit-desc">
              Enable teams to work together more effectively.
            </p>
          </div>
          <div className="custom-benefit-item">
            <div className="custom-benefit-icon-wrap">
              <FaSlidersH className="custom-benefit-icon" />
            </div>
            <p className="custom-benefit-title">Flexible Workflows</p>
            <p className="custom-benefit-desc">
              Adapt systems according to business requirements.
            </p>
          </div>
          <div className="custom-benefit-item">
            <div className="custom-benefit-icon-wrap">
              <FaExpandArrowsAlt className="custom-benefit-icon" />
            </div>
            <p className="custom-benefit-title">Scalable Systems</p>
            <p className="custom-benefit-desc">
              Solutions designed to support future growth.
            </p>
          </div>
          <div className="custom-benefit-item">
            <div className="custom-benefit-icon-wrap">
              <FaClock className="custom-benefit-icon" />
            </div>
            <p className="custom-benefit-title">Time Saving</p>
            <p className="custom-benefit-desc">
              Simplify repetitive activities and processes.
            </p>
          </div>
          <div className="custom-benefit-item">
            <div className="custom-benefit-icon-wrap">
              <FaSmile className="custom-benefit-icon" />
            </div>
            <p className="custom-benefit-title">Enhanced User Experience</p>
            <p className="custom-benefit-desc">
              Create easier and smoother workflows.
            </p>
          </div>
        </div>
      </section>
      
      {/* ================= CTA SECTION ================= */}
      <section className="custom-cta-section">
        <div className="custom-cta-content">
          <h2>
            Need A Solution Built Around
            <br />
            Your <span className="custom-cta-highlight">Business?</span>
          </h2>
          <p>
            Let's create customized solutions that simplify work, improve
            productivity, and support business growth.
          </p>
          <div className="custom-cta-buttons">
            <button className="custom-cta-btn custom-secondary-btn" onClick={handleNavigateToContact}>
              Contact Us
            </button>
          </div>
        </div>
      </section>
      <Footer/>
    </>
  );
}

export default CustomSolutionsPage;